<template>
	<div class="cell">
		<div class="cell-label" @click.stop.prevent>
			<div class="cell-icon__mr" v-if="$slots.leftIcon">
				<slot name="leftIcon"></slot>
			</div>
			<slot v-if="$slots.title" name="title"></slot>
			<div v-else class="cell-title">{{ title }}</div>
			<div class="cell-icon" v-if="$slots.rightIcon">
				<slot name="rightIcon"></slot>
			</div>
		</div>
		<div class="cell-content">
			<div v-if="desc">{{ desc }}</div>
			<slot name="content"></slot>
			<nut-icon
				v-if="isLink"
				class="nut-cell__link"
				name="right"
				class-prefix="icon"
				font-class-name="iconfont"
			></nut-icon>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CCellItem',
	props: {
		title: { type: String, default: '' },
		desc: { type: String, default: '' },
		isLink: { type: Boolean, default: false },
	},
	setup() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.cell {
	position: relative;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	width: 100%;
	line-height: 20px;
	padding: 13px 16px;
	background: #fff;
	border-radius: 6px;
	font-size: 14px;
	color: #666;

	&:after {
		position: absolute;
		box-sizing: border-box;
		content: ' ';
		pointer-events: none;
		bottom: 0;
		left: 0;
		right: 0;
		height: 1px;
		background: rgba(0, 0, 0, 0.15);
		transform: scaleY(0.5);
	}

	&-label {
		margin-right: 10px;
		display: flex;
		align-items: center;
	}

	&-icon {
		margin-left: 4px;
		&.cell-icon__mr {
			margin-left: 0;
			margin-right: 2px;
		}
	}

	&-content {
		text-align: right;
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		color: #ccc;
		font-size: 12px;
	}
}
</style>
